import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { Event } from 'react-socket-io';

import InlineSVG from './InlineSVG';
import PopupFaq from './PopupFaq';
import PopupNotification from './PopupNotification';
import PopupProfile from './PopupProfile';

import Autocomplete from '../lib/index';
import { styles } from '../lib/utils';

import { SpinLoader } from 'react-css-loaders';

@inject('ProductStore', 'AuthenticationStore', 'SearchStore', 'NotificationStore') @observer
class Header extends Component {
	static contextTypes = {
		socket: React.PropTypes.object.isRequired
	};

	constructor(props, context) {
		super(props, context);
		this.state = { openedMenu: null, openedPopup: null, activeNoticeTab: 'new_content_important' };
		this.onNotification = this.onNotification.bind(this);
		this.onConnection = this.onConnection.bind(this);
	}

	componentWillMount() {
		const { NotificationStore } = this.props;
		NotificationStore.fetchData();
	}

	onNotification(notification) {
		const { NotificationStore } = this.props;
		NotificationStore.addNotification(notification);
	}

	onConnection(message) {
		const { AuthenticationStore } = this.props;
		this.context.socket.emit('clientCustomToken', { customId: AuthenticationStore.user.id });
	}

	_changeActiveNoticeTab(activeNoticeTab, e) {
		e.stopPropagation();
		if (activeNoticeTab !== this.state.activeNoticeTab)
			this.setState({ activeNoticeTab });
	}

	_tooglePopup(name, opening = undefined, state = {}) {
		let popupState;
		if (opening === undefined)
			popupState = (this.state.openedPopup !== name) ? { openedPopup: name } : { openedPopup: null };
		else
			popupState = opening ? { openedPopup: name } : { openedPopup: null };

		if (popupState.openedPopup !== 'menu')
			state = Object.assign(popupState, { openedMenu: null }, state);
		else
			state = Object.assign(popupState, state);

		this.setState(state);
	}

	_closePopups() {
		if (this.state.openedPopup) {
			this._tooglePopup(this.state.openedPopup, false);
		}
	}

	_toogleMenu(menuItem) {
		if (!this.state.openedMenu || this.state.openedMenu !== menuItem || (this.state.openedMenu && this.state.openedPopup != 'menu'))
			this._tooglePopup('menu', true, { openedMenu: menuItem });
		else
			this._tooglePopup('menu', false);
	}

	_popupClassName(name) {
		if (this.state.openedPopup === name) return 'active';
	}

	_menuClassName(menuItem) {
		const menuItemPathRegex = {
			'novidades': /\/novidades/,
			'produtos': /\/p\//,
			'institucional': /\/institucional/,
			'ofertas': /\/ofertas-e-combos/,
			'documentos': /\/material-de-apoio/,
			'cursos': /\/cursos/
		};

		const { ProductStore } = this.props;
		if (this.state.openedMenu === menuItem)
			return (this.state.openedPopup === 'menu') ? 'active opened' : 'active';
		else {
			const regex = menuItemPathRegex[menuItem];
			if (regex && regex.test(this.props.match.url))
				return 'active selected';
		}
	}

	render() {
		const { ProductStore, AuthenticationStore, SearchStore, NotificationStore } = this.props;
		const { user, user: { user_group: { features } } } = AuthenticationStore;
		const spinner = SearchStore.searching ? <SpinLoader color="#aaa" size={2} className={SearchStore.hasResults ? 'spinner absolute' : 'spinner'} /> : false;
		return (
			<header className="wrapper" onClick={() => this._closePopups()}>
				<Event event="connect" handler={this.onConnection} />
				<Event event={`notification-${user.id}`} handler={this.onNotification} />

				{this.state.openedPopup && <div className="close-popups"></div>}

				<section className="container-navigation">
					<section className="main">
						<Link to="/novidades" className="logo">
							<img src={require('../img/logo.svg')} alt="" />
						</Link>
						
						<form className="search-box" onSubmit={e => e.preventDefault()}>
							<Autocomplete
								value={SearchStore.searchTerm}
								inputProps={{ placeholder: 'Buscar' }}
								items={SearchStore.searchItems.toJS()}
								getItemValue={(item) => item}
								onChange={(event, searchTerm) => SearchStore.search(searchTerm)}
								renderMenu={(items, value, style) => {
									return (
										<div className="content-oncomplete" style={{ ...style, ...menuStyle }}>
											{spinner}
											{items}
										</div>
									)
								}}
								onSelect={item => {
									switch (item.type) {
										case 'product':
											this.props.history.push(`/p/${item.section_slug}/${item.product_slug}`);
											this.props.history.push(`/p/${item.section_slug}/${item.product_slug}/itens/${item.category_id}`);
											break;
										case 'faq':
											this.props.history.push(`${this.props.match.url}/faqs/${item.section_id}/faq/${item.id}`);
											break;
										case 'post':
											this.props.history.push(`/novidades/ver/${item.slug}`);
											break;
										case 'course':
											this.props.history.push(`/cursos/ver/${item.slug}`);
											break;	
										case 'sale':
											this.props.history.push(`/ofertas-e-combos/${item.sale_slug}`);
											this.props.history.push(`/ofertas-e-combos/${item.sale_slug}/itens/${item.category_id}`);
											break;
										default:

									}
								}}
								renderItem={(item, isHighlighted) => {
									if (item.type === 'section') {
										return (
											<div className="section" key={`${item.type}-${item.name}`}>
												{item.name}
											</div>
										)
									}
									else {
										return (
											<div className="item" style={isHighlighted ? styles.highlightedItem : styles.item}
												key={`${item.type}-${item.id}`}>
												{(item.type === 'product') && (<span><strong>{item.product_name}</strong> em {item.product_content_category_name}</span>)}
												{(item.type === 'faq') && item.question}
												{(item.type === 'post') && item.title}
												{(item.type === 'course') && item.title}
												{(item.type === 'sale') && (<span><strong>{item.sale_name}</strong> em {item.product_content_category_name}</span>)}

												<img className="arrow-item" src={require('../img/arrow-search.png')} alt="" />
											</div>
										)
									}
								}}
							>
								<button>
									<img src={require('../img/icon-search.svg')} alt="" className="icon-normal" />
									<img src={require('../img/icon-search-focus.svg')} alt="" className="icon-focus" />
								</button>
							</Autocomplete>
						</form>

						<ul className="navigation-buttons">
						{ features.includes('FAQ') && (
							<li className={this._popupClassName('faq')}>
								<button className="faq navigation-item" onClick={(e) => {
									this._tooglePopup('faq');
									e.stopPropagation();
								}}>
									<div>
										<img src={require('../img/icon-faq-header.svg')} alt="Ícone FAQ" />
									</div>

									<span>FAQ</span>

									<img src={require('../img/icon-arrow-up-popup.png')} alt="" className="icon-arrow-up-popup" />
								</button>

								{this.state.openedPopup === 'faq' && <PopupFaq match={this.props.match} />}
							</li>
						)}

							<li className={this._popupClassName('notifications')}>
								<button className="notification navigation-item" onClick={(e) => {
									this._tooglePopup('notifications');
									e.stopPropagation();
								}}>
									<div>
										<img src={require('../img/icon-avisos-header.svg')} alt="Ícone notificações" />

										{NotificationStore.unreadNotificationsCount != 0 &&
											<span className="number">{NotificationStore.unreadNotificationsCount}</span>
										}
									</div>

									<span>Avisos</span>

									<img src={require('../img/icon-arrow-up-popup.png')} alt="" className="icon-arrow-up-popup" />
								</button>

								{this.state.openedPopup === 'notifications' && (
									<PopupNotification
										{...this.props}
										notificationStore={NotificationStore}
										activeTab={this.state.activeNoticeTab}
										onChangeTab={this._changeActiveNoticeTab.bind(this)} />
								)}
							</li>

							<li className={this._popupClassName('profile')}>
								<button className="profile navigation-item" onClick={(e) => {
									this._tooglePopup('profile');
									e.stopPropagation();
								}}>
									<div>
										<img src={require('../img/icon-profile-header.svg')} alt="Imagem do perfil" />
									</div>

									<span>Perfil</span>

									<img src={require('../img/icon-arrow-up-popup.png')} alt="" className="icon-arrow-up-popup" />
								</button>

								{this.state.openedPopup === 'profile' && <PopupProfile />}
							</li>
						</ul>
					</section>
				</section>

				<section className="main-menu">
					<section className="main">
						<ul>
							<li>
								<Link className={this._menuClassName('novidades')} onClick={(e) => this._closePopups()} to="/novidades" title="Novidades">
									<InlineSVG src={require('../img/icon-news.svg')} /> Novidades

									<span className="line" />
								</Link>
							</li>
						{ features.includes('PRODUCT') && (
							<li>
								<a className={this._menuClassName('produtos')}
									onClick={(e) => {
										this._toogleMenu('produtos');
										e.stopPropagation();
									}}
									title="Produtos">
									<InlineSVG src={require('../img/icon-products.svg')} /> Produtos
									<span className="arrow">
										<InlineSVG src={require('../img/icon-arrow-down-menu.svg')} />
									</span>
									<img src={require('../img/icon-arrow-up.png')} alt="" className="arrow-up" />

									<span className="line" />
								</a>
							</li>
						)}

						{ features.includes('SALE') && (
							<li>
								<Link className={this._menuClassName('ofertas')} onClick={(e) => this._closePopups()} to="/ofertas-e-combos" title="Campanhas">
									<InlineSVG src={require('../img/icon-sales.svg')} /> Campanhas
									<span className="line" />
								</Link>
							</li>
						)}
						{ features.includes('DOCUMENT') && (
							<li>
								<Link className={this._menuClassName('documentos')} onClick={(e) => this._closePopups()} to="/material-de-apoio" title="Material de apoio">
									<InlineSVG src={require('../img/icon-documents.svg')} /> Materiais de Apoio
								<span className="line" />
								</Link>
							</li>
						)}
						{ features.includes('COURSE') && (
							<li>
								<Link className={this._menuClassName('cursos')} onClick={(e) => this._closePopups()} to="/cursos" title="Universidade">
									<InlineSVG src={require('../img/icon-cursos.svg')} /> Universidade
								<span className="line" />
								</Link>
							</li>
						)}
							<li>
								<Link className={this._menuClassName('institucional')} onClick={(e) => this._closePopups()} to="/institucional" title="Institucional">
									<InlineSVG src={require('../img/icon-institucional.svg')} /> Institucional
									<span className="line" />
								</Link>
							</li>
						</ul>
					</section>
				</section>

				{
					this.state.openedPopup === 'menu' && this.state.openedMenu === 'produtos' &&
					<section className="submenu-container products">
						<section className="main">
							<ul>
								{ProductStore.sections.map((section) => (
									<li key={section.id}>
										<strong className="section-name">
											{section.name}
										</strong>
								{ section.categories && (
									<ul className="section-categories">
										{section.categories.map((category) => (
											<li key={category.id}>
												<span className="category-name">{category.name}</span>
												
												<ul>
													{category.products.map((product) => (
														<li key={product.id}>
															<NavLink onClick={() => this._tooglePopup('menu', false)} to={`/p/${section.slug}/${product.slug}`} title={product.name}>{product.name}</NavLink>
														</li>
													))
													}
												</ul>
											</li>
										))}
									</ul>
								)}
										<ul className="products-no-category">
											{section.products.map((product) => (
												<li key={product.id}>
													<NavLink onClick={() => this._tooglePopup('menu', false)} to={`/p/${section.slug}/${product.slug}`} title={product.name}>{product.name}</NavLink>
												</li>
											))
											}
										</ul>
									</li>
								))
								}
							</ul>
						</section>
					</section>
				}
			</header >
		);
	}
}

const menuStyle = {
	borderRadius: '4px',
	boxShadow: '0 11px 24px 0 rgba(0,0,0,0.25)',
	background: '#fff',
	padding: '2px 0',
	fontSize: '90%',
	position: 'absolute',
	top: '90%',
	left: '0',
	zIndex: '-9',
	width: '100%',
	overflow: 'auto',
	minHeight: '0',
	maxHeight: '300px', // TODO: don't cheat, let it flow to the bottom
};

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js